<div class="widget-container" [routerLink]="['/energia/' + contract.ContractId + '/consumos']">
    <div class="header">
        <div class="d-flex flex-column">
            <span class="header-title">{{ "pt.edp.edponline.consumptions.smartnow.widget.title" | translate }}</span>
            <span class="header-description">{{ "pt.edp.edponline.consumptions.smartnow.widget.description" | translate }}</span>
        </div>
        <i class="icon-edponline-Bop-023"></i>
    </div>

    <div class="body">
        <div class="body-wrapper">
            <div class="body-value">
                {{ consumption?.total }}
                <span class="body-unit">{{ "pt.edp.edponline.smartnow.electricityUnit" | translate }}</span>
            </div>
            <div class="body-date">
                <span class="mr-1">
                    {{ "pt.edp.edponline.smartnow.since" | translate }} <span class="font-weight-bold" *ngIf="consumption?.start">{{ (consumption?.start | date: "dd MMM").replace(".", "") }}</span>
                </span>
                <span>{{ "pt.edp.edponline.smartnow.untilNow" | translate }}</span>
            </div>
        </div>
        <i class="icon-edponline-Bra-001 d-none d-lg-block"></i>
        <i class="icon-edponline-Bop-001 d-block d-lg-none"></i>
    </div>
    <div *ngIf="!prediction && !consumption?.diffToPrevious && !offlineTime; else comparisonPrediction" class="footer d-none d-lg-flex">
        {{ "pt.edp.edponline.consumptions.smartnow.widget.noData" | translate }}
    </div>

    <div *ngIf="!!offlineTime" class="footer d-block footer-offline">
        {{ 'pt.edp.edponline.consumptions.smartnow.offline.device' | translate }} <strong> {{ 'pt.edp.edponline.consumptions.smartnow.offline.off' | translate}}</strong>.   {{ 'pt.edp.edponline.consumptions.smartnow.offline.lastUpdate' | translate }} <strong> {{ offlineTime }}</strong>. {{'pt.edp.edponline.consumptions.smartnow.offline.connection' | translate}}
    </div>

    <ng-template #comparisonPrediction >
        <div class="footer" *ngIf="!offlineTime">
            <div class="d-flex" [ngClass]="{ 'flex-column has-prediction': prediction }" *ngIf="consumption?.diffToPrevious">
                <span class="footer-value" [ngClass]="{ 'no-prediction': !prediction }">
                    <i
                        class="icon-edponline-Bop-078 mr-2"
                        [ngClass]="{
                            'rotate-90 edp-color-eletric-green-01': consumption?.diffPercentage <= 0,
                            'rotate-270 edp-color-error-01': consumption?.diffPercentage > 0
                        }"
                    ></i>
                    <span class="d-flex" [ngClass]="{ 'flex-column': !prediction }">
                        <span class="d-flex mr-1">
                            <b>{{ consumption?.diffToPrevious }}</b>
                            <span class="unit">{{ "pt.edp.edponline.smartnow.electricityUnit" | translate }}</span>
                        </span>
                        <span class="font-weight-300">({{ consumption?.diffPercentage }}%)</span>
                    </span>
                </span>
                <span class="footer-label" [innerHTML]="'pt.edp.edponline.smartnow.compareWithLastPeriod' | translate"></span>
            </div>

            <div class="d-flex flex-column" *ngIf="prediction">
                <span class="footer-value">{{ prediction?.value }} <span class="unit">{{ "pt.edp.edponline.smartnow.electricityUnit" | translate }}</span></span>
                <span class="footer-label">
                    <b>{{ "pt.edp.edponline.smartnow.prediction" | translate }}</b>
                    <br />
                    {{ "pt.edp.edponline.smartnow.endOfPeriod" | translate }}
                </span>
            </div>
        </div>
    </ng-template>
</div>
